/** Review request template shared by Settings → Reviews and the project Review tab. */

export const REVIEW_PLACEHOLDERS = [
  { key: 'clientName', label: 'Client first name' },
  { key: 'service', label: 'Service' },
  { key: 'serviceDate', label: 'Service date' },
  { key: 'companyName', label: 'Company name' },
];

export const DEFAULT_REVIEW_SUBJECT =
  'How did we do, {{clientName}}? Share your {{service}} experience';

export const DEFAULT_REVIEW_MESSAGE =
  'Thank you for choosing {{companyName}} for your {{service}}, completed on {{serviceDate}}. ' +
  'We hope your space feels fresh, calm, and beautifully cared for.\n\n' +
  "We'd love to hear how everything went — your feedback helps our team keep improving.";

export const REVIEW_SETTINGS_QUERY = `
  query ReviewSettings {
    getMyProfile {
      id
      company {
        id
        companyName
        googleReviewUrl
        reviewRequestSubject
        reviewRequestMessage
      }
    }
  }
`;

/** Replace {{placeholders}}; unknown ones are left as typed so mistakes stay visible. */
export function fillReviewTemplate(template, values) {
  return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
    values[key] != null && values[key] !== '' ? String(values[key]) : match,
  );
}

/** Accepts only https links (Google review links are always https). */
export const isValidReviewUrl = (url) => /^https:\/\/\S+$/i.test(String(url || '').trim());
